import React from "react";

const DUE_BADGE_CLASSES = {
  overdue: "bg-[var(--follow-up-overdue-bg)] text-[var(--follow-up-overdue-fg)]",
  today: "bg-[var(--follow-up-today-bg)] text-[var(--follow-up-today-fg)]",
  upcoming: "bg-[var(--follow-up-upcoming-bg)] text-[var(--follow-up-upcoming-fg)]",
  done: "bg-[var(--follow-up-done-bg)] text-[var(--follow-up-done-fg)]",
};

// Where a follow-up stands (see getDueState), sized like the list tables' badges
export const DueBadge = ({ dueState }) => (
  <span
    className={`inline-block w-fit whitespace-nowrap px-2 py-1 border-radius text-[length:var(--list-table-row-badges-font-size)] font-[var(--follow-up-label-fw)] ${
      DUE_BADGE_CLASSES[dueState?.key] ?? DUE_BADGE_CLASSES.upcoming
    }`}
  >
    {dueState?.label}
  </span>
);
